import script from "./TransactionErrorView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionErrorView.vue?vue&type=script&setup=true&lang=js"

import "./TransactionErrorView.vue?vue&type=style&index=0&id=7a164572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a164572"]])

export default __exports__